const ME_TOKEN = '__me__';
const ANCHOR_AI_TOKEN = '__anchor_ai__';
const ACTOR_TOKENS = [
    ME_TOKEN,
    ANCHOR_AI_TOKEN
];
export const isExcludeMode = (predicate)=>predicate.nin != null && predicate.nin.length > 0;
const actorLabel = (value, meLabel, anchorAiLabel)=>{
    if (value === ME_TOKEN) return meLabel;
    if (value === ANCHOR_AI_TOKEN) return anchorAiLabel !== null && anchorAiLabel !== void 0 ? anchorAiLabel : value;
    return value;
};
export const valueLabelFor = (predicate, meLabel, anchorAiLabel)=>{
    var _predicate_nin, _predicate_in;
    const values = isExcludeMode(predicate) ? (_predicate_nin = predicate.nin) !== null && _predicate_nin !== void 0 ? _predicate_nin : [] : (_predicate_in = predicate.in) !== null && _predicate_in !== void 0 ? _predicate_in : [];
    return values.map((value)=>actorLabel(value, meLabel, anchorAiLabel)).join(', ');
};
export const namesActorToken = (predicate)=>{
    var _predicate_in, _predicate_nin;
    return [
        ...(_predicate_in = predicate.in) !== null && _predicate_in !== void 0 ? _predicate_in : [],
        ...(_predicate_nin = predicate.nin) !== null && _predicate_nin !== void 0 ? _predicate_nin : []
    ].some((value)=>ACTOR_TOKENS.includes(value));
};
export const currentValue = (predicate)=>{
    var _predicate_nin, _predicate_in;
    return (isExcludeMode(predicate) ? (_predicate_nin = predicate.nin) !== null && _predicate_nin !== void 0 ? _predicate_nin : [] : (_predicate_in = predicate.in) !== null && _predicate_in !== void 0 ? _predicate_in : []).join(', ');
};
